import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaEye,
  FaEyeSlash,
  FaHome,
  FaBuilding,
  FaUserCircle,
  FaLock,
} from "react-icons/fa";
import "./Login.css";
import { tokenUrl, apiUrl, envCode } from "../Constant";
import CustomLoader from "../static/CustomLoader";
import { toast } from "sonner";

export const configPath = createContext();

const Login = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [custCode, setCustCode] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [agree, setAgree] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && userId && password && custCode && agree) {
      handlesubmit(userId, password, custCode);
    }
  };

  const getConfigValue = (configArr, targetKey) => {
    if (Array.isArray(configArr) && configArr.length > 0) {
      const found = configArr.find(
        (item) => item?.code?.toLowerCase() === targetKey.toLowerCase(),
      );
      return found?.val || null;
    }
    return null;
  };

  const handlesubmit = async (user, pwd, custCode) => {
    if (!user || !pwd || !custCode) {
      toast.error("Customer code,User ID and Password are required!");
      return;
    }
    if (!agree) {
      toast.error("Please agree to the Terms & Conditions and Privacy Policy.");
      return;
    }
    setLoading(true);
    try {
      const headers = {
        "Content-Type": "application/json",
        version: "1.0.0",
      };
      const loginData = {
        name: user,
        password: pwd,
        custCode: custCode,
      };
      const resp = await axios.post(
        `${tokenUrl}customer/tokenexpressmodify`,
        loginData,
        { headers },
      );
      const data = resp.data;
      if (data.cd === 1) {
        toast.error(data.description);
        setLoading(false);
      }
      if (Array.isArray(data) && data[0]?.accessToken) {
        const accessToken = data[0].accessToken;
        const parsedresponse = JSON.parse(data[1]);
        const config = parsedresponse.config || [];
        const resolvedApiUrl = getConfigValue(config, "apiUrl") || apiUrl;
        const resolvedEnvCode = getConfigValue(config, "envCode") || envCode;
        const normalizedOrgCode = custCode?.trim().toLowerCase();
        localStorage.setItem("user", JSON.stringify(parsedresponse.user));
        localStorage.setItem(
          "functions",
          JSON.stringify(parsedresponse.functions),
        );
        localStorage.setItem("org", JSON.stringify(parsedresponse.org));
        localStorage.setItem(
          "dropDowns",
          JSON.stringify(parsedresponse.dropDowns),
        );
        localStorage.setItem("dbTokenData", accessToken);
        localStorage.setItem("custCode", normalizedOrgCode);
        localStorage.setItem("apiUrl", resolvedApiUrl);
        localStorage.setItem("envcode", resolvedEnvCode);
        toast.success("Login successful");
        window.location.reload();
        window.location.href = "/workitemdashboard";
      }
    } catch (error) {
      toast.error("Some issue Please Check Network connection..");
      console.error("Login error:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="background login-split-page">
      <div className="login-split-overlay" />

      <button
        type="button"
        className="login-home-button"
        aria-label="Go to home"
        onClick={() => navigate("/")}
      >
        <FaHome size={20} />
      </button>

      <div className="login-shell">
        <section className="login-form-panel">
          <div className="login-form-inner">
            <div className="login-logo-wrap">
              <div className="login-logo-ring">
                <img
                  src="/loaderLogo.png"
                  alt="App Logo"
                  className="login-logo"
                />
              </div>
            </div>

            <div className="login-heading">
              <h2>Welcome back</h2>
              <p>Enter your credentials to continue.</p>
            </div>

            <div className="login-fields">
              <div className="login-field">
                <label htmlFor="custCodeInput">Organization Code</label>
                <div className="login-input-wrap">
                  <span className="login-input-icon">
                    <FaBuilding size={14} />
                  </span>
                  <input
                    id="custCodeInput"
                    autoFocus
                    type="text"
                    placeholder="Enter organization code"
                    value={custCode}
                    disabled={loading}
                    onChange={(e) => setCustCode(e.target.value)}
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      document.getElementById("userIdInput").focus()
                    }
                  />
                </div>
              </div>

              <div className="login-field">
                <label htmlFor="userIdInput">User ID</label>
                <div className="login-input-wrap">
                  <span className="login-input-icon">
                    <FaUserCircle size={15} />
                  </span>
                  <input
                    id="userIdInput"
                    type="text"
                    placeholder="Enter User ID"
                    value={userId}
                    disabled={loading}
                    onChange={(e) => setUserId(e.target.value)}
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      document.getElementById("passwordInput").focus()
                    }
                  />
                </div>
              </div>

              <div className="login-field">
                <label htmlFor="passwordInput">Password</label>
                <div className="login-input-wrap">
                  <span className="login-input-icon">
                    <FaLock size={14} />
                  </span>
                  <input
                    id="passwordInput"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Password"
                    value={password}
                    disabled={loading}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="login-password-toggle"
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                    onClick={togglePasswordVisibility}
                    disabled={loading}
                  >
                    {showPassword ? (
                      <FaEyeSlash size={17} />
                    ) : (
                      <FaEye size={17} />
                    )}
                  </button>
                </div>
              </div>
            </div>

            <label className="login-terms">
              <input
                type="checkbox"
                id="termsCheckbox"
                checked={agree}
                onChange={() => setAgree(!agree)}
                disabled={loading}
              />
              <span>
                I agree to the{" "}
                <a href="/terms" target="_blank" rel="noopener noreferrer">
                  Terms & Conditions
                </a>{" "}
                and{" "}
                <a href="/privacy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>
                .
              </span>
            </label>

            <button
              type="button"
              className={`login-submit ${loading ? "is-loading" : ""}`}
              disabled={loading}
              onClick={() => handlesubmit(userId, password, custCode)}
            >
              <span>{loading ? "Logging in..." : "Sign In"}</span>
            </button>
          </div>
        </section>
      </div>

      {loading && <CustomLoader />}
    </div>
  );
};

export default Login;